import React from "react";

import { Container, MovingContainer } from "./styles";

import panasonicLogo from "../../img/marqueelogos/panasonic-logo.png";
import ibmLogo from "../../img/marqueelogos/ibm-logo.png";
import nationalDigifoundryLogo from "../../img/marqueelogos/national-digifoundry-logo.png";
import simbaChainLogo from "../../img/marqueelogos/simba-chain-logo.png";
import forwardEdgeAiLogo from "../../img/marqueelogos/forward-edge-ai-logo.png";
import snowflakeLogo from "../../img/marqueelogos/snowflake-logo.png";
import foursquareLogo from "../../img/marqueelogos/foursquare-logo.png";
import airforceLogo from "../../img/marqueelogos/airforce-logo.png";
import awsLogo from "../../img/marqueelogos/aws-logo.png";
import heliumLogo from "../../img/marqueelogos/helium-logo.png";
import upholdLogo from "../../img/marqueelogos/uphold-logo.png";


const ImageSet = [
  <img src={panasonicLogo} alt="panasonicLogo" />,
  <img src={ibmLogo} alt="ibmLogo" />,
  <img src={nationalDigifoundryLogo} alt="nationalDigifoundryLogo" />,
  <img src={simbaChainLogo} alt="simbaChainLogo" />,
  <img src={forwardEdgeAiLogo} alt="forwardEdgeAiLogo" />,
  <img src={snowflakeLogo} alt="snowflakeLogo" />,
  <img src={foursquareLogo} alt="foursquareLogo" />,
  <img src={airforceLogo} alt="airforceLogo" />,
  <img src={awsLogo} alt="awsLogo" />,
  <img src={heliumLogo} alt="heliumLogo" />,
  <img src={upholdLogo} alt="upholdLogo" />,
];

function Marquee({ height, backgroundColor }) {
  return (
    <Container height={height}>
      <MovingContainer backgroundColor={backgroundColor}>
        {/* give the ilussion it returns */}
        {[...ImageSet, ...ImageSet, ...ImageSet, ...ImageSet]}
      </MovingContainer>
    </Container>
  );
}

export default Marquee;
